import { render } from "./CardChangeCompany.vue?vue&type=template&id=6ebfe433&scoped=true"
import script from "./CardChangeCompany.vue?vue&type=script&lang=js"
export * from "./CardChangeCompany.vue?vue&type=script&lang=js"

import "./CardChangeCompany.vue?vue&type=style&index=0&id=6ebfe433&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebfe433"]])

export default __exports__